import { create } from "zustand";

type PopupStore = {
    //state..
    maps: boolean;
    review: boolean;
    confirmation: boolean;
    packages: boolean;
    instructions: boolean;
    validation: boolean;
    uploadError: boolean;
    uploadErrorMsg: boolean;
    statusUpdate: boolean;
    imagePreview: boolean;

    //chats-state:
    fetchingChats: boolean;
    chatsLoading: boolean;
    chatIdFound: boolean;
    appAlert: boolean;
    appError: boolean;

    //mutations..
    setStatusUpdate: (val: boolean) => void
    setChatsLoading: (val: boolean) => void
    setChatIdFound: (val: boolean) => void
    setPopState: (state: string, value: boolean | string) => void;
}

export const usePopupStore = create<PopupStore>((set, get) => ({
    maps: false,
    review: false,
    packages: false,
    validation: false,
    instructions: false,
    confirmation: false,
    uploadError: false,
    uploadErrorMsg: false,
    statusUpdate: false,
    imagePreview: false,

    fetchingChats: true,
    chatsLoading: false,
    chatIdFound: false,
    appAlert: false,
    appError: false,

    setPopState: (state, value) => {
        set((prevState) => ({
            ...prevState,
            [state]: value
        }));
    },
    setChatsLoading: (val) => set({ chatsLoading: val }),
    setStatusUpdate: (val) => set({ statusUpdate: val }),
    setChatIdFound: (val) => set({ chatIdFound: val }),
}));